import { useEffect } from "react";
import useUIBp from "../../../../../../../Hooks/useUIBoilerplate";
import { useWorker } from "../../../../../../../Hooks/useWorker";
import Button from "../../../../../../UI/GeneralPurpose/Button";
import updateExclusions, { updateExclusionsUI } from "../../../Actions/updateExclusions";
import { selectedCommonUI } from "../../Category/Category";
import { customExtensionsUI } from "../../CustomExtensions/Top/NewExtension";
import { exclusionDevicesUI } from "../../DevicesList/Components/Headers";
import { exclusionDevicesData } from "../../DevicesList/DevicesList";
import { problematicUI } from "../../Problematic/Problematic";

const UIText = {
  "es-CL": { label: "Guardar" },
  "en-US": { label: "Save" },
};

const Save = () => {
  const { auth, dispatch, navigate, UI, warehouse, settings } = useUIBp();
  const { done, working, error } = useWorker(updateExclusionsUI);
  const locale = settings.locale;
  const customExtensions = UI[customExtensionsUI] ?? [];
  const standartExtensions = UI[selectedCommonUI] ?? [];
  const problematicExtensions = UI[problematicUI] ?? [];
  const exclusionDevices = UI[exclusionDevicesUI] ?? [];
  const devices = warehouse[exclusionDevicesData];

  useEffect(() => {
    if (done && !error) {
      navigate(-1);
    }
  }, [navigate, done, error]);

  const handleClick = () => {
    // save all
    let newExclusionsArray = [...standartExtensions.map((x) => `*.${x}`), ...customExtensions.map((x) => `*.${x}`), ...problematicExtensions];
    let newExclusions = newExclusionsArray.join("\n");

    console.log("devices from warehouse:", devices);
    console.log("exclusionDevices from UI:", exclusionDevices);

    let updateData = [];
    for (const idx in devices) {
      if (exclusionDevices.includes(devices[idx].mid)) {
        updateData.push({
          user: devices[idx].user,
          mid: devices[idx].mid,
          exclusions: newExclusions,
          token: auth.token,
        });
      }
    }
    // for (const mid of exclusionDevices) {
    //   let device;
    //   for (const idx in devices) {
    //     if (!!devices[idx][mid]) {
    //       device = devices[idx][mid];
    //     }
    //   }
    //   // const device = devices[mid];

    //   if (device) {
    //     updateData.push({
    //       user: device.user,
    //       mid,
    //       exclusions: newExclusions,
    //       token: auth.token,
    //     });
    //   }
    // }
    console.log("Update data prepared:", updateData);
    dispatch(updateExclusions({ ...auth, updateData, locale }));
  };

  return <Button {...{ UIText, onClick: handleClick, working, size: { xs: 6, sm: 6, md: "auto" } }} />;
};

export default Save;
